import { createContext, useContext } from 'react'
import type { AuthState, AuthUser } from '../lib/session'

export type { AuthUser, AuthState }

export interface AuthContextValue extends AuthState {
	setAuth: (auth: AuthState) => void
	logout: () => void
	isLoading: boolean
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)

export const useAuth = () => {
	const ctx = useContext(AuthContext)
	if (!ctx) throw new Error('useAuth must be used within AuthProvider')
	return ctx
}
